import React from 'react'

import './index.less';

export default function HeaderBanner(props: {
  firstLine?: string;
  secondLine?: string;
  children?: React.ReactNode;
  className?: string;
}) {
  const { firstLine = "Hi～", secondLine = "你想问我什么呢？", children, className } = props;
  return (
    <div className={`header-banner ${className || ""}`}>
      <div className='header-banner__main'>{firstLine}</div>
      <div className='header-banner__main'>{secondLine}</div>
      {
        children ? children : <>
          <div className='header-banner__sub'>我是开鸿数字人，您的个人办公助手，很高兴为您服务。</div>
          <div className='header-banner__sub-mini'>目前我拥有记录你的工时，进行知识库总结问答、IT知识咨询等技能。</div>
        </>
      }
    </div>
  )
}
